module.exports = __webpack_public_path__ + "static/media/firebase-seeklogo.com.bfa69c4f.svg";